export default "__VITE_ASSET__Bi$jZuC4__"